import { render, staticRenderFns } from "./JdSortTabs.vue?vue&type=template&id=086abd2a&scoped=true&"
import script from "./JdSortTabs.vue?vue&type=script&lang=js&"
export * from "./JdSortTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086abd2a",
  null
  
)

export default component.exports